import { useEffect } from 'react';

// Escape-to-close plus the body scroll lock, for a modal that is `open`.
// `lockScroll` is opt-in because only the disclaimer modal froze the page
// behind it in the original; the others left the page scrollable.
export function useModalBehaviour(open, onClose, { lockScroll = false } = {}) {
  useEffect(() => {
    if (!open) return undefined;

    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);

    const previousOverflow = lockScroll ? document.body.style.overflow : null;
    if (lockScroll) document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', onKeyDown);
      if (lockScroll) document.body.style.overflow = previousOverflow;
    };
  }, [open, onClose, lockScroll]);
}
